// =====================================
//
//   針對訂單顯示正確的規格 Controller
//   Author: Alan
//   createtime: 2016 / 03 / 07
//
// =====================================

window.InifECApp.directive('orderitemSpec', ['ProductUtil', function(ProductUtil) {

    var _dir = {};

    var controller = ['$scope', function($scope) {

        var PdtSpecProps = ProductUtil.PdtSpecProps;

        // ------------------------------
        // init
        // ------------------------------
    	var init = function() {
            
    		if(!$scope.orderitem) {
    			return;
    		}

    		$scope.spec = $scope.orderitem.spec;
            $scope.specid = $scope.spec.specid;
    		$scope.specProps = $scope.spec.specProps;
            $scope.showLargeDelivery = $scope.orderDelivery == OrderDeliveryType.HOME;
        }
        
        // ------------------------------
        // 取得尺寸
        // ------------------------------
        var getSizeUnit = function(key) {

            var specProps = $scope.specProps;
            var unit = specProps[key];

            return ProductUtil.getSizeUnitHtml(unit);
        }

        // ------------------------------
        // 取得尺寸
        // ------------------------------
        var getSizeUnitByInt = function(unit) {

            return ProductUtil.getSizeUnitHtml(unit);
        }

        // ------------------------------
        // 取得衣服尺寸代碼文字
        // ------------------------------
        var getClothingSizeUnitText = function(clothingSize) {

            var text = '';

            if(!clothingSize) {
                return text;
            }            

            if(clothingSize.clothingSizeunit === ProductUtil.ClothingSizeUnit.CUSTOM) {
                text = text + clothingSize.customSizeName;
            } else {
                text = text + ProductUtil.getClothingSizeUnitText(clothingSize.clothingSizeunit);
            }

            // if(clothingSize.remark) {
            //     text = text + '(' + clothingSize.remark + ')';
            // }

            return text;
        }

        // ------------------------------
        // 取得設計需求
        // ------------------------------
        var getDesignRequirement = function(type) {

            return ProductUtil.getProductDesignRequirementTypeText(type);
        }

        // ------------------------------
        // 取得印刷方式代碼文字
        // ------------------------------
        var getPdtPrintingTypeText = function(type) {

            return ProductUtil.getPdtPrintingTypeText(type);
        }

        // ------------------------------
        // [SCOPE] 取得顏色style
        // ------------------------------
        var getColorBackgroundStyle = function(color) {

            if(!color || !color.hex) {
                return undefined;
            }

            if(color.subHex) {
                return {
                    background: 'linear-gradient(-45deg, ' + color.subHex + ' 50%, ' + color.hex + ' 50%)',
                };
            } else {
                return {
                    backgroundColor: color.hex,
                }
            }
        }

        //==========================
        //  Event
        //==========================
        $scope.$watchGroup(['orderitem', 'orderitem.spec', 'orderDelivery'], function(newValues, oldValues, scope) {
            init();
        });

        //==========================
        //  Members
        //==========================
        $scope.spec = undefined;
        $scope.specid = undefined;
        $scope.specProps = undefined;
        $scope.orderitem;
        $scope.orderDelivery;
        $scope.showLargeDelivery = false;
        $scope.ProductDeliveryType = ProductUtil.ProductDeliveryType;
        $scope.PdtSpecProps = PdtSpecProps;

        //==========================
        //  Methods
        //==========================
        $scope.getSizeUnit = getSizeUnit; // 取得尺寸
        $scope.getSizeUnitByInt = getSizeUnitByInt; // 取得尺寸
        $scope.getClothingSizeUnitText = getClothingSizeUnitText; // 取得衣服尺寸代碼文字
        $scope.getDesignRequirement = getDesignRequirement; // 取得設計需求
        $scope.getPdtPrintingTypeText = getPdtPrintingTypeText; // 取得印刷方式代碼文字
        $scope.getColorBackgroundStyle = getColorBackgroundStyle; // 取得顏色style

        //==========================
        //  Init
        //==========================
        // init();

    }];

    _dir.restrict = 'AE';
    _dir.scope = {
        orderitem: '=',
        orderDelivery: '=',
    };
    _dir.replace = true;
    _dir.templateUrl = "partials/directives/orderitem_spec.html";
    _dir.controller = controller;

    return _dir;

}]);
